import React from "react";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import CovidStater from "../../Images/covid_image.png";
import ECommerce from "../../Images/e-commerce.png";
import AlgoVisualizer from "../../Images/algo-visualizer.png";
import ReactLogo from "../../Images/react-logo.png";
import JavaScriptLogo from "../../Images/javascript-logo.png";
import JavaLogo from "../../Images/java-logo.png";
import JavaProjectImage from "../../Images/java-project-image.png";

function ProjectPage() {
  return (
    <div>
      <h1 className="page-header">My Projects</h1>
      <ProjectCard
        image={ECommerce}
        heading="E-commerce"
        toolsList={[ReactLogo, JavaScriptLogo]}
        descript="Developed an e-commerce website using React, JavaScript, and SCSS, featuring checkout, sign in, sign up and sign out functionality. Utilized and connected with Firebase to store and retrieve the data of the shop items and login users"
        codeLink="https://github.com/leodan2002/E-Commerce"
        demoLink="https://anhoang-fashion.netlify.app/" //Live link
      />
      <ProjectCard
        image={AlgoVisualizer}
        heading="Algorithm Visualizer"
        toolsList={[ReactLogo, JavaScriptLogo]}
        descript="Developed a responsive website using React, JavaScript, and CSS to visualize sorting and pathfinding algorithms.Implemented Dijkstra, A*, Breadth First Search, Depth First Search, Bubble sort, Insertion sort, Selection sort, Merge sort, and Quick sort algorithms."
        codeLink="https://github.com/leodan2002/AlgorithmVisualizer"
        demoLink="https://anhoang-algo.netlify.app/" //Live link
      />
      <ProjectCard
        image={CovidStater}
        heading="Covid Tracker"
        toolsList={[ReactLogo, JavaScriptLogo]}
        descript="A React application that helps track the number of Covid cases across all the provinces in Canada, by fetching the data from the opencovid API."
        codeLink="https://github.com/leodan2002/covid-tracker"
        demoLink="https://covid19tracker-anhoang.netlify.app/" //Live link
      />
      <ProjectCard
        image={JavaProjectImage}
        heading="Flight Reservation System"
        toolsList={[JavaLogo]}
        descript="An OOP Java-based project that simulates a flight reservation system that can help passengers with many activities including reserving or cancelling seats, printing all the flights, checking if seats are available, sorting aircraft and flights."
        codeLink="https://github.com/leodan2002/Flight_Reservation_System_P2"
        demoLink="https://github.com/leodan2002/Flight_Reservation_System_P2"
      />
    </div>
  );
}
export default ProjectPage;
